export default "__VITE_ASSET__DS5d9Tyx__"